// DS: DS6.1.3
import React from 'react';
import c from 'classnames';
import omit from 'lodash/omit';
import BiDiv, { type BiDivProps } from '@wix/da-bi/pkg/Components/BiDiv';
import { setRef } from '../../../../../utils/refHelpers';
import { CommonListItemAPI, EffectStrength, useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import s from './ListItemDiv.scss';

export interface Props
  extends Omit<BiDivProps, 'prefix' | 'innerRef' | 'tabIndex'>,
    CommonListItemAPI {}

/**
 * A plain, uninteractive ListItem implementation
 */
const ListItemDiv: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: { className, ...rest },
    contentProps,
    ref,
  } = useListItem<HTMLDivElement, Props>(unfilteredProps, {
    hover: EffectStrength.None,
  });
  return (
    <BiDiv
      innerRef={node => setRef(ref, node)}
      className={c(rest.checked && s['selected'], className)}
      {...omit(rest, ['disabled', 'checked', 'isInteractive'])}
    >
      <ListItemContent {...contentProps} />
    </BiDiv>
  );
};

ListItemDiv.displayName = 'ListItemDiv';

export default ListItemDiv;
